export function upravStranku() {
  Lc.f("upravStranku - onas.js");
  return false;

  /* eslint-disable no-unreachable */
  let kod = `
<section class="about-hero">
  <div class="cntmax">
    <div class="about-hero__text">
      <h1>Kryjeme záda českým šermířům od roku 1991</h1>
      <h2>Protože i d'Artagnan měl svého pátého mušketýra.</h2>
      <p>
        Šerm je nádherný sport. Ještě než zazní „En garde“, musí každý šermíř
        pilovat přesnost, fyzickou zdatnost i psychickou odolnost. Šerm umí být
        vznešené umění i tvrdý sport, který se neobejde bez spolehlivé zbraně a
        kvalitního vybavení.
      </p>
      <p>
        A my se snažíme, aby jediné, co na planši budete vnímat, byla tíha
        situace, ne váha výbavy. 5M je česká rodinná firma, která pod vedením
        olympionika Jiřího Berana spojuje tradici českého šermu s vlastní
        výrobou.
      </p>
      <a href="/historie-5M/" class="about-hero__btn">Kde se vzalo 5M?</a>
    </div>
  </div>
</section>
<section class="beran-section">
  <div class="flx">
    <div class="leva">
      <h2>Jmenuji se <strong>Jiří Beran</strong>. A v 5M hraji dvojí roli</h2>
      <p>
        Možná mě znáte z televize. Na LOH v Paříži 2024 jsme pro český šerm
        vyhráli senzační bronz. Zatímco na planši jsem schovaný pod maskou, v 5M
        jdu s kůží na trh. Snažím se spojovat dva zcela rozdílné světy.
      </p>
      <ul class="ul1">
        <li>Bronz na LOH v Paříži 2024</li>
        <li>Cena Fair Play z Ria (charakter je totiž víc než vítězství)</li>
        <li>Inženýr zaměřený na technický vývoj produktů</li>
        <li>Bubeník, protože život i šerm potřebuje rytmus</li>
      </ul>
      <h3>Jsem šermíř</h3>
      <p>
        Vím, jaké to je, když vás ve finále zradí kord. Mám za sebou 33 let na
        planši, cenu Fair Play i olympijský bronz. Díky tomu se umím vcítit do
        toho, co šermíři všech úrovní prožívají – byl jsem tam totiž taky.
      </p>
      <h3>Jsem inženýr</h3>
      <p>
        Tohle je moje druhá tvář. Na vybavení se nedívám jen přes emoce, ale
        přes čísla a fyzikální vlastnosti, pnutí materiálů i gramy. Jako inženýr
        vím, že „pocitově lehčí“ nic neříká. Zlepšení musí být měřitelné.
      </p>
      <h3>Výsledek?</h3>
      <p>
        V 5M vám nedoporučím nic, co neprošlo mýma rukama. Berte to jako moji
        osobní garanci kvality.
      </p>
    </div>
    <div class="prava">
      <img
        src="/user/documents/ladzo_v1/img/o-nas/beran-o-nas-c.png"
        alt="Jiří Beran s bronzovou medailí"
      />
    </div>
  </div>
</section>
<section class="beran-podcast">
  <h2>Podcasty o šermu, vybavení i kariéře</h2>
  <div class="flx">
    <div class="leva">
      <a href="">
      <img
        src="/user/documents/ladzo_v1/img/o-nas/host1.png"
        alt=""
      />
      </a>
      <p>lorem ipsum</p>
      <a href="" class="button">Přehrát</a>
    </div>
    <div class="prava">
    <a href="">
      <img
        src="/user/documents/ladzo_v1/img/o-nas/host2.png"
        alt=""
      />
      </a>
      <p>lorem ipsum</p>
      <a href="" class="button">Přehrát</a>
    </div>
  </div>
</section>
<section class="beran-section satna">
 <div class="flx">
    <div class="leva">
    <img
        src="/user/documents/ladzo_v1/img/o-nas/satna.png"
        alt=""
      />
    </div>
    <div class="prava">
      <h2>Proč vyrábíme vlastní šermířskou výbavu?<br>
      Protože dobré nám nestačilo.</h2>
      <p>
      Každá firma má svůj příběh. Ten náš kopíruje vývoj českého šermu. Od nedostatku všeho v začátcích po dnešní profesionalizaci šermu jako sportu.
      </p>
      <h3>1991<br>Všechno začal táta</h3>
      <p>
      V devadesátkách můj otec Jiří Beran st. s kamarádem Honzou Tůmou založili firmu 5M (všimnout si můžete nenápadného odkazu na legendu o pátém mušketýrovi). Tenkrát čeští šermíři neměli skoro ani s čím bojovat, takže šlo o rozhodnutí z čiré nutnosti. Začali proto shánět aspoň nějaké vybavení a založili klub SC Praha, aby komunitě dopřáli základní zázemí.
      </p>
      <h3>1992–2002<br>Zlatá dekáda</h3>
      <p>
      Firma se začala rozrůstat a několik let měla i kamennou prodejnu v Mánesově ulici v Praze. 5M rozjelo vlastní výrobu tašek, podkolenek, číšek a dalšího vybavení přímo v České republice. Stali jsme se výhradními distributory jedné z nejznámějších světových značek šermířského vybavení, firmy Allstar.
      </p>

      <h3>2002–2007<br>Odklon od výroby</h3>
      <p>
      Růst zpomalil a pozornost se z vlastní výroby přesunula čistě na distribuci produktů značky Allstar. Když jsem končil studium na ČVUT, přistihnul jsem se, že až příliš často přemýšlím o tom, jak 5M posunout dál. V roce 2006 jsem to nevydržel a spustil první e-shop 5mfencing.com. Začala se psát druhá kapitola naší rodinné firmy.    
      </p>
      
      
    </div>
  </div>
</section> 
<section class="beran-section zbytek">
  <div class="zbytek">
  <h3>2008–2025<br>Nová krev českého šermu</h3>
  <p>
  Firmu jsem od táty v roce 2008 celou převzal. Výbavy bylo na trhu už dost, vývoj ale stagnoval. Šermíři tahali zbytečnou váhu, a proto jsem spojil tátovu tradici se svým technickým vzděláním. Oprášili jsme stroje a pustili se do vývoje. A následně i výroby vlastní řady vybavení 5M Supra.
  </p>
  <p>
  Nechtěli jsme jen dovážet renomované zahraniční značky. Chtěli jsme výbavu vylepšovat. Například díky speciálním vláknům jsou naše dresy o stovky gramů lehčí než běžná konkurence. Na celodenním turnaji to znamená tuny ušetřené zátěže.
  </p>
  <p>
  Vyvíjet jsme začali nové oblečení nejen pro profíky, ale hlavně pro hobíky a děti. Šel jsem do toho s vizí co nejrychleji nabídnout základní oblečení na šerm v dobré kvalitě a za nejlepší cenu všem. To se povedlo a o šerm se začali zajímat sportovní nadšenci, rodiče i děti. Střihy oblečení Victory dodnes patří mezi nejoblíbenější na trhu.
  </p> 
  </div>
</section>
<img
        src="/user/documents/ladzo_v1/img/o-nas/souboj.jpg"
        alt=""
/>

<section class="beran-section fond">
  <h2>Nadační fond Šerm dětem</h2>
  <h3>Vychováváme šermíře, kteří nás budou porážet</h3>

  <p>A nemůžeme se toho dočkat. Medaile z olympiády je sice krásná věc, ale skončí zaprášená ve vitríně. Moc si přejeme, aby tu po 5M zůstávalo víc. Věříme, že šerm je ta nejlepší škola charakteru, a proto skrze nadaci Šerm dětem vracíme našemu sportu to, co dal on nám.</p>

  <ul class="ul2">
    <li><strong>Tour de školy</strong><br>Zvedáme děti od počítačů a vozíme šerm přímo do tělocvičen. Do konce roku 2025 si přes 10 000 dětí mohlo šerm vyzkoušet na 75 místech po celé ČR.</li>
  

    <li><strong>Teambuildingy</strong><br>Nadaci nám pomáhá financovat prodej zážitků pro firmy a přátele. Díky tomu můžeme radost ze sportu šířit po celém Česku.</li>
    <li><strong>Granty a podpora</strong><br>Pokud má dítě talent, ale chybí prostředky, jsme tu my. Fond podporuje vznik nových šermířských oddílů a nadané mladé šermíře.</li>
    <li><strong>Hodnoty Fair Play</strong><br>Učíme, že po zásahu se nevzteká, ale podává se ruka.</li>
  </ul>


<p>Každým nákupem v 5M pomáháte otevřít cestu na planš dalším holkám a klukům. Děkujeme, že jste v tom s námi.
</p>
</section>

<div class="fotky">
  <div class="flx">
    <img
        src="/user/documents/ladzo_v1/img/o-nas/01.jpg"
        alt=""
/>
<img
        src="/user/documents/ladzo_v1/img/o-nas/02.jpg"
        alt=""
/>
<img
        src="/user/documents/ladzo_v1/img/o-nas/03.jpg"
        alt=""
/>
  </div>
</div>

<section class="nadace">
  <div class="flx">
    <div class="leva">
      <div>
      <strong>Podpořit naši nadaci můžete i vy</strong><br>
      Podívejte se na její webové stránky a zjistěte, co všechno děláme
      </div>
    </div>
    <div class="prava">
      <a href="/podporujeme/">Více o naší nadaci</a>
    </div>
  </div>
</section>

`;
  $("article >div").html(kod);

  $(".about-hero").insertBefore($("#content-wrapper"));
}
